import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import React from 'react';
import { string, func, node, oneOf, oneOfType, bool, shape } from 'prop-types';
import { Icon } from '@magalu/stereo-ui-icons';
import { ButtonBase, StartIcon, Content, EndIcon } from './button.styles';

const Button = _ref => {
  let {
    onClick
  } = _ref,
      props = _objectWithoutPropertiesLoose(_ref, ["onClick"]);

  const {
    startIcon,
    endIcon,
    children,
    disabled
  } = props;

  const getIcon = icon => typeof icon === 'string' ? /*#__PURE__*/React.createElement(Icon, {
    name: icon
  }) : icon;

  return /*#__PURE__*/React.createElement(ButtonBase, _extends({
    onClick: e => onClick(e)
  }, props), startIcon && /*#__PURE__*/React.createElement(StartIcon, null, getIcon(startIcon)), /*#__PURE__*/React.createElement(Content, {
    disabled: disabled
  }, children), endIcon && /*#__PURE__*/React.createElement(EndIcon, null, getIcon(endIcon)));
};

process.env.NODE_ENV !== "production" ? Button.propTypes = {
  centered: bool,
  children: node,
  color: string,
  customColor: shape({
    default: string,
    hover: string
  }),
  disabled: bool,
  endIcon: oneOfType([node, string]),
  invertedColors: bool,
  onClick: func,
  rounded: bool,
  size: oneOf(['small', 'medium', 'large']),
  startIcon: oneOfType([node, string]),
  uppercase: bool,
  variation: string
} : void 0;
Button.defaultProps = {
  centered: false,
  children: undefined,
  color: 'primary',
  customColor: {
    default: null,
    hover: null
  },
  disabled: false,
  invertedColors: false,
  onClick: () => {},
  rounded: false,
  size: 'medium',
  uppercase: true,
  variation: 'fill'
};
Button.displayName = 'Button';
export default Button;